<template>
  <div class="section sec1" :class="{activepage:showIndex==0}">
    <div class="sec-body">

      <div class="left">
        <div class="yxgj-logo">
          <img src="../../assets/images/page1/yxgj.png" alt />
        </div>
          <div class="sub-title">赋能信息部门，提升全院服务</div>
        <div class="yxgj-introduce">
          <div
            style="font-size:32px;color:#fff;text-shadow:5px 5px 5px rgba(20,58,176,.5);line-height:1;margin-top:20px;margin-bottom:30px;"
          >医院信息工作好管家！</div>
          <div class="introduce">
            <p>“医信管家” 是医院信息管理和服务工作的一体化平台。</p>
            <p>包含工作计划、项目建设实施、运维管理、服务管理、评级评审服务等功能、覆盖规划设计、部署实施、服务运营、持续改进和监督管理等全生命周期阶段。</p>
            <p>通过强化对信息工作的目标管理、过程管控、环节记录、结果反馈，更便捷的实现科室协作、全院互动，让IT工作发挥更强效能，为全院提升服务质量、提高服务效率贡献力量。</p>
          </div>
        </div>
        <div class="apply-free">
          <!-- <div class="contract">
            <input type="text" placeholder="电子邮箱或手机" />
          </div>-->
          <div class="apply pointer" @click="register">立即申请</div>
        </div>
      </div>
      <div class="right">
        <img src="../../assets/images/page1/page_3.png" alt="医信管家" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "HelloWorld",
    props: ["showIndex"],
    data() {
        return {};
    },
    methods: {
    // aTest() {
    //   this.$axios.post("/api", {
    //       unitName: "instant",
    //       userName: "yhy",
    //       phoneNumber: "18256913205"
    //     })
    //     .then(function(response) {
    //       console.log(response);
    //     })
    //     .catch(function(error) {
    //       console.log(error);
    //     });
    // },
        register(){
            this.$router.push({path:"/registerPage"});
        }
    }
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.sec1 {
  background: url("../../assets/images/page1/bg_2.png") center no-repeat;
  background-size: 100% 100%;
  position: relative;
}

.sec1 .sec-body{
  display:flex;
  align-items: center;
  width:1024px;
  height:606px;
  position:absolute;
  top:50%;
  left:50%;
  transform: translateX(-50%)translateY(-50%);
}


.sec1 .sec-body .right {
  position: absolute;
  right:0;
  top:calc(50% + 25px);
  transform:translateY(-50%);
}

.sec1 .sec-body .left {
  width: 567px;
  height:427px;
  text-align: left;
  z-index:20;
}

.sec1 .left .introduce p {
  margin: 0;
  text-indent: 2em;
  font-size: 17px;
  line-height: 30px;
  color: #fff;
}


.sec1 .apply-free .apply {
  font-size: 24px;
  line-height: 58px;
  width: 365px;
  border-radius: 20px;
  background-color: #86cdf9;
  color: #1e3b8c;
  text-align: center;
  opacity: 0;
  margin-top: 28px;
  /* opacity: 0;
  transition: all linear; */
}

.sec1 .apply-free .apply:hover{
  background-color: #76c3e7;
}


/* animations */

.sec-body .yxgj-logo {
  margin-left: -50px;
}
.section.activepage .sec-body .yxgj-logo {
  animation: toRight 1s ease-in 0.5s;
  animation-fill-mode: forwards;
}
.sec-body .sub-title{
    background: linear-gradient(to bottom, #f0ffff, #8defff);
    -webkit-background-clip: text;
    color: transparent;
    font-size:24px;
    margin-top: 5px;
}

.section.activepage .sec-body .yxgj-introduce {
  animation: body 1.5s ease-in;
  animation-fill-mode: forwards;
}

.section.activepage .sec-body .apply {
  animation: apply 0.5s linear 1s;
  animation-fill-mode: forwards;
}

@keyframes apply {
  0% {
    margin-top: 60px;
    opacity: 0;
  }
  100% {
    margin-top: 30px;
    opacity: 1;
  }
}

@keyframes body {
  0% {
    opacity: 0.5;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes toRight {
  0% {
    margin-left: -50px;
  }
  100% {
    margin-left: 0;
  }
}


@media screen and (max-width: 1366px){
  .sec1 .sec-body{
  width:1024px;
  height:506px;
  top:calc(50% + 30px);
}

  .sec1 .left .introduce p {
    line-height: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homePage/firstPage.vue